import React, { createContext, type FC, useEffect, useState } from 'react';

import useService from '@/lib/hooks/useService';
import type { ChargingPile } from '@/types/database/chargingPile/chargingPile';
import type { ChargingPileElectricityRate } from '@/types/database/chargingPile/chargingPileElectricityRate';
import type { ChargingPileGroup } from '@/types/database/chargingPile/chargingPileGroup';

import type { ContextType } from '../../types';

export const GroupContext = createContext<ContextType>({
  groupData: [],
  chargingPileData: [],
  currentGroup: null,
  setCurrentGroup: () => null,
  chart: null,
  setChart: () => null,
  manualControl: false,
  sortBy: 'householdNumber',
  setSortBy: () => null,
});

export const PileCtxProvider: FC = ({ children }) => {
  const [currentGroup, setCurrentGroup] = useState<ChargingPileGroup | null>(
    null
  );
  const [chart, setChart] = useState<{
    show: boolean;
    type: string;
    id: string;
    name: string;
  } | null>(null);
  const [sortBy, setSortBy] = useState<
    'householdNumber' | 'parkingNumber' | 'chargingPileID'
  >('householdNumber');

  const [chargingPileData] = useService<ChargingPile>({
    collectionName: 'chargingPile',
  });

  const [groupData] = useService<ChargingPileGroup>({
    collectionName: 'chargingPileGroup',
  });

  const [chargingSetting] = useService<ChargingPileElectricityRate>({
    collectionName: 'chargingPileElectricityRate',
  });

  useEffect(() => {
    if (groupData.length > 0) {
      setCurrentGroup(groupData[0]);
    }
  }, [groupData]);

  return (
    <GroupContext.Provider
      value={{
        groupData,
        chargingPileData,
        currentGroup,
        setCurrentGroup,
        chart,
        setChart,
        manualControl: chargingSetting?.[0]?.manualControl ?? false,
        sortBy,
        setSortBy,
      }}
    >
      {children}
    </GroupContext.Provider>
  );
};
